import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { Box, Grid2, Link, Stack, Typography, useTheme } from "@mui/material";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";
import EGDatePicker from "../../../../MainComponents/DatePicker/EGDatePicker";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import { InvestigationButton } from "../components/InvestigationButton";
import { ChipParticipant, InvestigationCollapsable, Separator } from "../components/InvestigationComponents";
import { AddQuestionsToInterview } from "./Modals/AddQuestionsToInterview";
import { useConstants } from "../Main/useConstants";
import { useSelector } from "react-redux";
import { interviewSchema } from "./schemas";
import { SectionedSelect } from "../../../../MainComponents/Select/SectionedSelect";
import { RichTextEditor } from "../../../../MainComponents/RichTextEditor/RichTextEditor";
import { enums } from "../Main/enums";


// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (form) => {
  const { interviewed, interviewer, kind, interview } = form;
  const errors = {};
  if (!interviewed || (typeof interviewed === "object" && !interviewed.id)) {
    errors.interviewed = true;
  }
  if (!interviewer) {
    errors.interviewer = true;
  }
  if (!kind) {
    errors.kind = true;
  }
  // if (interview.length === 0) {
  //   errors.interview = true;
  // }
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
}

export const AddInterview = ({
  interviews,
  selectedInterview,
  setSelectedInterview,
  setIsAdding,
  handleSaveInterviews,
  alias,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const email = useSelector((state) => state.auth.email);
  const { interviews: { typeInterviewOpts, statusOpts, connectionProviderOpts }, selects: { hoursOpts } } = useConstants();

  const jaguarState = useSelector((state) => state.jaguar);
  const { enums, selects: { typeUserLabels } } = useConstants();

  const [interview, setInterview] = useState(_.cloneDeep(interviewSchema));
  const [participants, setParticipants] = useState([]);
  const [selectedQuestionForEdit, setSelectedQuestionForEdit] = useState(null);
  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});

  const [isLoadingInterviewForEdit, setIsLoadingInterviewForEdit] = useState(true);

  const [setInterViewDate, setSetInterViewDate] = useState(false);
  const [addParticipants, setAddParticipants] = useState(false);
  const [addInterviewGoals, setAddInterviewGoals] = useState(false);
  const [addInterviewDetailsPlaceOrConnection, setAddInterviewDetailsPlaceOrConnection] = useState(false);
  const [showAddQuestionsModal, setShowAddQuestionsModal] = useState(false);
  const [typeOfQuestions, setTypeOfQuestions] = useState("manual"); // manual | template

  const [participant, setParticipant] = useState({
    id: "",
    from: "",
  });
  const [role, setRole] = useState("");
  const [isOtherInterviewed, setIsOtherInterviewed] = useState(
    selectedInterview != null && interviews[selectedInterview]?.interviewed?.from === "other"
  );

  const interviewedOpts = useMemo(() => {
    const { COMPLAINANT, LEADER, PEOPLE, INVOLVEDS_ACCOMPLICE, INVOLVEDS_OFFENDER, INVOLVEDS_VICTIM, INVOLVEDS_WITNESS } = enums.typeUser;
    const usersWanted = [COMPLAINANT, LEADER, PEOPLE, INVOLVEDS_VICTIM, INVOLVEDS_ACCOMPLICE, INVOLVEDS_OFFENDER, INVOLVEDS_WITNESS];

    let newIndicatedOpts = [];

    usersWanted.forEach((value) => {
      if (value === COMPLAINANT) {
        newIndicatedOpts.push({
          key: value,
          options: [{
            value: COMPLAINANT,
            label: t("Denunciante"),
          }],
        });
        return;
      }
      if (value === LEADER) {
        newIndicatedOpts.push({
          key: value,
          options: [{
            value: LEADER,
            label: "Lider",
          }],
        });
        return;
      }
      if (value === PEOPLE) {
        newIndicatedOpts.push({
          key: value,
          options: [{
            value: PEOPLE,
            label: "People",
          }],
        });
        return;
      }
      const fromArray = _.get(jaguarState, enums.typeUserRoutes[value])?.formatted || [];
      newIndicatedOpts.push({
        label: typeUserLabels[value],
        key: value,
        options: fromArray,
      });
    });

    newIndicatedOpts.push({
      key: "other",
      options: [{
        value: "other",
        label: t("Otro"),
      }],
    });

    return newIndicatedOpts;
  }, [jaguarState]);
  
  // Select for assign the activity
  const interviewerOpts = useMemo(() => {
    const { ME, RESOURCES, EXTERNAL, SYSTEM } = enums.typeUser;
    const usersWanted = [ME, RESOURCES, EXTERNAL, SYSTEM];

    let newSections = [];

    usersWanted.forEach((value) => {
      if (value === ME) {
        newSections.push({
          key: value,
          options: [
            {
              value: email,
              label: "Asignarme la entrevista",
            },
          ],
        });
        return;
      }
      const fromArray =
        _.get(jaguarState, enums.typeUserRoutes[value])?.formatted || [];
      newSections.push({
        label: typeUserLabels[value],
        key: value,
        options: fromArray,
      });
    });

    // Disable party from selections
    participants.forEach((participant) => {
      const { id, from } = participant ?? {};
      const findedSectionIdx = newSections.findIndex(
        (section) => section.key === from
      );
      if (findedSectionIdx !== -1) {
        newSections[findedSectionIdx].options = newSections[
          findedSectionIdx
        ].options.map((option) => {
          if (option.value === id) {
            return { ...option, disabled: true };
          }
          return option;
        });
      }
    });

    return newSections;
  }, [participants, jaguarState]);

  // Select for add participants
  const participantsSections = useMemo(() => {
    const { ME, RESOURCES, EXTERNAL, SYSTEM } = enums.typeUser;
    const usersWanted = [ME, RESOURCES, EXTERNAL, SYSTEM];

    let newSections = [];

    usersWanted.forEach((value) => {
      if (value === ME) {
        newSections.push({
          key: value,
          options: [
            {
              value: email,
              label: "Participar en la entrevista",
            },
          ],
        });
        return;
      }
      const fromArray =
        _.get(jaguarState, enums.typeUserRoutes[value])?.formatted || [];
      newSections.push({
        label: typeUserLabels[value],
        key: value,
        options: fromArray,
      });
    });

    // Kick assigned from selections
    const { id, from } = interview.interviewer ?? {};
    const findedSectionIdx = newSections.findIndex(
      (section) => section.key === from
    );
    if (findedSectionIdx !== -1) {
      newSections[findedSectionIdx].options = newSections[
        findedSectionIdx
      ].options.map((option) => {
        if (option.value === id) {
          return { ...option, disabled: true };
        }
        return option;
      });
    }

    // Disable party from selections
    participants.forEach((participant) => {
      const { id, from } = participant ?? {};
      const findedSectionIdx = newSections.findIndex(
        (section) => section.key === from
      );
      if (findedSectionIdx !== -1) {
        newSections[findedSectionIdx].options = newSections[
          findedSectionIdx
        ].options.map((option) => {
          if (option.value === id) {
            return { ...option, disabled: true };
          }
          return option;
        });
      }
    });

    return newSections;
  }, [interview.interviewer, participants, jaguarState]);
  
  
  useEffect(() => {
    if (selectedInterview != null) {
      const currentInterview = interviews[selectedInterview];
      setInterview(currentInterview);
      setParticipants(currentInterview.witness || []);
      setSetInterViewDate(!!currentInterview.scheduled);
      setAddParticipants(!!currentInterview.witness && currentInterview.witness.length > 0);
      setAddInterviewGoals(!!currentInterview.details);
      setAddInterviewDetailsPlaceOrConnection(!!currentInterview.kindDetails || !!currentInterview.connectionProvider);
    }
    setIsLoadingInterviewForEdit(false)
  }, [selectedInterview]);

  // Validar cada que se hace un cambio
  useEffect(() => {
    if (triedToSave) {
      const [_, errors] = validateForm(interview);
      setErrors(errors);
    }
  }, [interview]);

  const handleChange = (e, diff) => {
    if (diff === "scheduled") {
      const newDate = e;
      setInterview({ ...interview, scheduled: newDate ? dayjs(newDate).format('YYYY-MM-DD') : null });
    } else if (diff === "record") {
      const { name, checked } = e.target;
      setInterview({ ...interview, [name]: checked });
    } else {
      const { name, value } = e.target;
      setInterview({ ...interview, [name]: value });
    }
  }

  const handleChangeSectionedSelect = (name, { value, section }, resetParticipant) => {
    setInterview({ ...interview, [name]: { id: value, from: section } });
    if (resetParticipant) {
      setParticipant({
        id: "",
        from: "",
      });
    }
  }

  const handleAddParticipant = () => {
    if (participants.some(item => item.id === participant.id)) {
      enqueueSnackbar({ variant: "error", message: t("Este participante ya existe") });
      return;
    }
    setParticipant({
      id: "",
      from: "",
    });
    setRole("");

    setParticipants((prev) => [...prev, {
      id: participant.id,
      from: participant.from,
      role,
    }]);
  };

  const handleDeleteParticipant = (idx) => {
    const newParticipants = [...participants];
    newParticipants.splice(idx, 1);
    setParticipants(newParticipants);
  }


  const handleEditQuestion = (idx) => {
    const findQuestion = interview.interview[idx];
    setSelectedQuestionForEdit({ ...findQuestion , idx });
    setShowAddQuestionsModal(true);
    setTypeOfQuestions("manual");
  }

  const handleDeleteQuestion = (idx) => {
    const newQuestions = _.cloneDeep(interview.interview);
    newQuestions.splice(idx, 1);
    setInterview({ ...interview, interview: newQuestions });
  }

  // Cierra el modal y resetear el tipo de preguntas
  const handleCloseModalAddQuestions = () => {
    setShowAddQuestionsModal(false);
    setTimeout(() => {
      setTypeOfQuestions(null);
    }, 200);
  }

  const handleClose = () => {
    setSelectedInterview(null);
    setIsAdding(false);
  }

  const handleSave = () => {
    const [isValid, errors] = validateForm(interview);
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
      return;
    };
    const newInterviews = _.cloneDeep(interviews || []);

    const objToSave = {
      ...interview,
      witness: participants,
      last_updated: dayjs().format('YYYY-MM-DD'),
    }

    if (selectedInterview == null) {
      newInterviews.push(objToSave);
    } else {
      newInterviews[selectedInterview] = objToSave;
    }
    handleSaveInterviews(newInterviews);
  }

  const returnIsValid = (error) => {
    if (!triedToSave) return null;
    if (error) return false;
    return true;
  }

  if (isLoadingInterviewForEdit) return <></>

  return (
    <>
      <AddQuestionsToInterview // MODAL
        show={showAddQuestionsModal}
        onHide={handleCloseModalAddQuestions}
        selectedQuestionForEdit={selectedQuestionForEdit}
        setSelectedQuestionForEdit={setSelectedQuestionForEdit}
        interview={interview}
        setInterview={setInterview}
        typeOfQuestions={typeOfQuestions}
        alias={alias}
      />
      <Box padding={2}>
        
        <Separator text={selectedInterview != null ? t("Editar entrevista") : t("Agregar nueva entrevista")} />

        <Grid2 container spacing={2} mt={2}>
          
          <Grid2 size={{ xs: 12, lg: 4 }}>
            <EGBasicSelect
              label={t("Estatus de la entrevista")}
              name="status"
              value={interview.status}
              onChange={handleChange}
              options={statusOpts}
              showHelpText={false}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" justifyContent="space-between">
            <Typography fontSize={16} fontWeight={600} color={theme.palette.secondary.main}>
              {t("Establecer fecha de entrevista")}
            </Typography>
            <EGSwitch 
              size="small"
              checked={setInterViewDate} 
              onChange={(e) => setSetInterViewDate(e.target.checked)}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            {
              setInterViewDate &&
              <>
                <EGDatePicker
                  label={`${t("Fecha")}`}
                  name="scheduled"
                  value={interview.scheduled ? dayjs(interview.scheduled) : null}
                  onChange={(e) => handleChange(e, "scheduled")}
                  className="date-picker-deadline"
                  format="DD/MMM/YYYY"
                />
                
                <Box width={140}>
                  <EGBasicSelect
                    label={t("Hora")}
                    name="timeScheduled"
                    value={interview.timeScheduled}
                    onChange={handleChange}
                    options={hoursOpts}
                    showHelpText={false}
                  />
                </Box>
              </>
            }
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            {
              typeof interview.interviewed === "string" ? ( // Para compatibilidad
                <EGInput
                  label={t("Entrevistado")}
                  name="interviewed"
                  value={interview.interviewed}
                  onChange={handleChange}
                  type="text"
                  required={true}
                  isValid={returnIsValid(errors?.interviewed) ?? null}
                  showSuccessValidation
                  showHelpText={false}
                />
              ) : (
                <SectionedSelect
                  label={t("Entrevistado")}
                  value={isOtherInterviewed ? "other" : (interview.interviewed?.id ?? "")}
                  onChange={(e) => {
                    if (e.value === "other") {
                      setIsOtherInterviewed(true);
                      setInterview({ ...interview, interviewed: { id: "", from: "other" } });
                    } else {
                      setIsOtherInterviewed(false);
                      handleChangeSectionedSelect("interviewed", e);
                    }
                  }}
                  sections={interviewedOpts}
                  required={true}
                  isValid={returnIsValid(errors?.interviewed) ?? null}
                  showSuccessValidation
                  showHelpText={false}
                />
              )
            }
          </Grid2>
          {isOtherInterviewed && (
            <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" gap={1}>
              <EGInput
                label={t("Nombre del entrevistado")}
                value={interview.interviewed?.id === "other" ? "" : (interview.interviewed?.id ?? "")}
                onChange={(e) => {
                  setInterview({ ...interview, interviewed: { id: e.target.value, from: "other" } });
                }}
                type="text"
                required={true}
                isValid={returnIsValid(errors?.interviewed) ?? null}
                showSuccessValidation
                showHelpText={false}
              />
            </Grid2>
          )}

          <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <SectionedSelect
              label={t("Entrevistador")}
              value={interview.interviewer?.id ?? ""}
              onChange={(e) => handleChangeSectionedSelect("interviewer", e, true)}
              sections={interviewerOpts}
              required={true}
              isValid={returnIsValid(errors?.interviewer) ?? null}
              showSuccessValidation
              showHelpText={false}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 4 }} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <Typography fontSize={16} fontWeight={600} color={theme.palette.secondary.main}>
              {t("Agregar participantes")}
            </Typography>
            <EGSwitch 
              size="small"
              checked={addParticipants} 
              onChange={(e) => setAddParticipants(e.target.checked)}
            />
          </Grid2>

        </Grid2>

        {
          addParticipants &&
          <AddParticipants
            participants={participants}
            participant={participant}
            setParticipant={setParticipant}
            role={role}
            setRole={setRole}
            participantsSections={participantsSections}
            handleAddParticipant={handleAddParticipant}
            handleDeleteParticipant={handleDeleteParticipant}
          />
        }

        <Box>
          {
            addInterviewGoals ? (
              <EGInput
                label={`${t("Objetivos de la entrevista")}`}
                name="details"
                value={interview.details}
                onChange={handleChange}
                type="textarea"
                multiline
                rows={5}
                sx={{ mt: 2 }}
              />
            ) : (
              <Link
                onClick={() => setAddInterviewGoals(true)}
                underline="hover"
                display="block"
                mt={1}
              >
                + Agregar objetivos de la entrevista
              </Link>
            )
          }
        </Box>

        <Grid2 container spacing={2} mt={2}>
          
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <EGBasicSelect
              label={t("Tipo de entrevista")}
              name="kind"
              value={interview.kind}
              onChange={handleChange}
              options={typeInterviewOpts}
              isValid={returnIsValid(errors?.kind) ?? null}
              required
              showSuccessValidation
              showHelpText={false}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 6 }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography fontSize={16} fontWeight={600} color={theme.palette.secondary.main}>
                {t("Entrevista grabada")}
              </Typography>
              <EGSwitch 
                size="small"
                name="record"
                checked={interview.record} 
                onChange={(e) => handleChange(e, "record")}
              />
            </Box>
            <Typography fontSize={12} fontWeight={400} color={theme.palette.secondary.main} fontStyle="italic">
              {t("*Puedes subir la grabación una vez que guardes la entrevista")}
            </Typography>
          </Grid2>

        </Grid2>

        {
          interview.kind &&
          <Grid2 container spacing={2}>
            {
              addInterviewDetailsPlaceOrConnection ? (
                <>
                  {
                    interview.kind === "in-person" &&
                    <EGInput
                      label={t("Agregar detalles del lugar")}
                      name="kindDetails"
                      value={interview.kindDetails}
                      onChange={handleChange}
                      multiline
                      rows={5}
                      sx={{ mt: 2 }}
                    />
                  }
                  {
                    interview.kind === "video-conference" &&
                    <>
                      <Grid2 size={{ xs: 12, lg: 4 }} sx={{ mt: 2 }}>
                        <EGBasicSelect
                          label={t("Proveedor de conexión")}
                          name="connectionProvider"
                          value={interview.connectionProvider}
                          onChange={handleChange}
                          options={connectionProviderOpts}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, lg: 8 }} sx={{ mt: 2 }}>
                        <EGInput
                          label={t("Liga de acceso")}
                          name="kindDetails"
                          value={interview.kindDetails}
                          onChange={handleChange}
                        />
                      </Grid2>
                    </>
                  }
                </>
              ) : (
                <Link
                  onClick={() => setAddInterviewDetailsPlaceOrConnection(true)}
                  underline="hover"
                  display="block"
                  mt={1}
                >
                  {interview.kind === "in-person" ? t("+ Agregar detalles del lugar") :   t("+ Agregar detalles de conexión de la reunión")}
                </Link>
              )
            }
          </Grid2>
        }

        {
          interview.interview.length > 0 &&
          <Stack 
            spacing={2} 
            mt={2}
            p={2}
            borderRadius="5px"
            border={`1px solid ${ 
              returnIsValid(errors?.interview) == null
              ? theme.palette.primary.main
              : returnIsValid(errors?.interview)
                ? theme.palette.green.main
                : theme.palette.red.main
            }`}
          >
            
            <Stack
              direction={{ xs: "column", md: "row" }} 
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <InvestigationItemContainer
                color={theme.palette.primary.main}
                width="fit-content"
                sx={{ padding: .8 }} 
              >
                <Typography fontSize={13} fontWeight={600}>
                  {t("Preguntas de la entrevista")}
                </Typography>
              </InvestigationItemContainer>

              {/* <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1}>
                <InvestigationButton
                  label={`${t("DESDE PLANTILLA")}`}
                  icon="outline_export"
                  size="medium"
                  onClick={() => handleTypeOfQuestions("template")}
                  />
                <InvestigationButton 
                  label={`${t("AGREGAR")}`}
                  size="medium"
                  icon="add_circle"
                  onClick={() => handleTypeOfQuestions("manual")}
                />
              </Stack> */}

            </Stack>

            {
              interview.interview.length > 0 &&
              <>
                <hr style={{ margin: 0 }} />
                <DragDropContext onDragEnd={(result) => {
                  if (!result.destination) return;
                  
                  const items = Array.from(interview.interview);
                  const [reorderedItem] = items.splice(result.source.index, 1);
                  items.splice(result.destination.index, 0, reorderedItem);
                  
                  setInterview(prev => ({
                    ...prev,
                    interview: items
                  }));
                }}>
                  <Droppable droppableId="questions">
                    {(provided) => (
                      <Stack 
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {
                          interview.interview.map((question, idx) => (
                            <Draggable 
                              key={idx} 
                              draggableId={`question-${idx}`} 
                              index={idx}
                            >
                              {(provided, snapshot) => (
                                <Box
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    opacity: snapshot.isDragging ? 0.8 : 1,
                                  }}
                                  sx={{
                                    my: .5,
                                  }}
                                >
                                  <InvestigationCollapsable
                                    dragHandleProps={provided.dragHandleProps}
                                    title={
                                      <Stack spacing={.2}>
                                        <Typography fontSize={16} fontWeight={600}>
                                          {question.question}
                                        </Typography>
                                        {
                                          question.details &&
                                          <Typography component="span" fontSize={12} fontWeight={600} color={theme.palette.secondary.main}>
                                            {t("Detalles de la pregunta")}: &nbsp;
                                            <Typography component="span" fontSize={12} fontWeight={400}>
                                              {question.details}
                                            </Typography>
                                          </Typography>
                                        }
                                      </Stack>
                                    }
                                    details={ question.answer &&
                                      <Stack>
                                        <Typography fontSize={14} fontWeight={600} color={theme.palette.secondary.main}>
                                          {t("Respuesta")}:
                                        </Typography>
                                        <RichTextEditor
                                          value={question.answer}
                                          justView={true}
                                        />
                                        {
                                          question.answerDetails &&
                                          <Typography component="span" fontSize={12} fontWeight={600} color={theme.palette.secondary.main}>
                                            {t("Detalles de la respuesta")}: &nbsp;
                                            <Typography component="span" fontSize={12} fontWeight={400}>
                                              {question.answerDetails}
                                            </Typography>
                                          </Typography>
                                        }
                                      </Stack>
                                    }
                                    buttons={[
                                      {
                                        tooltip: t("Eliminar pregunta"),
                                        name: "trash_can",
                                        color: theme.palette.red.main,
                                        onClick: () => handleDeleteQuestion(idx),
                                      },
                                      {
                                        tooltip: t("Editar pregunta"),
                                        name: "outline_edit",
                                        color: theme.palette.primary.main,
                                        onClick: () => handleEditQuestion(idx),
                                      }
                                    ]}
                                  />
                                </Box>
                              )}
                            </Draggable>
                          ))
                        }
                        {provided.placeholder}
                      </Stack>
                    )}
                  </Droppable>
                </DragDropContext>
              </>
            }
            
          </Stack>
        }

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1} mt={2}>
          <InvestigationButton
            label={`${t("causes.cancel")}`}
            icon="close_icon"
            onClick={handleClose}
            />
          <InvestigationButton 
            label={`${t("causes.save")}`}
            variant="success"
            icon="mark_check_bold"
            onClick={handleSave}
          />
        </Stack>
      </Box>
    </>
  )
};

const AddParticipants = ({
  participants,
  participant,
  setParticipant,
  role,
  setRole,
  participantsSections,
  handleAddParticipant,
  handleDeleteParticipant,
}) => {

  const theme = useTheme();
  const [t] = useTranslation("investigation");

  const { interviews: { rolesOpts }, functions: { getUserLabel } } = useConstants();

  return (
    <Grid2 container spacing={1} mt={2}>

      <Grid2 size={{ xs: 12, lg: 5 }}>
        <SectionedSelect
          label={t("Participante")}
          value={participant.id}
          onChange={(opt) => setParticipant({ id: opt.value, from: opt.section })}
          sections={participantsSections}
          showHelpText={false}
        />
      </Grid2>
      
      <Grid2 size={{ xs: 12, lg: 5 }}>
        <EGBasicSelect
          label={t("Rol")}
          value={role}
          onChange={(e) => setRole(e.target.value)}
          options={rolesOpts}
          showHelpText={false}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 2 }}>
        <EGButton 
          label="AGREGAR"
          size="medium"
          fullWidth
          onClick={handleAddParticipant}
          disabled={typeof participant === "string" ? participant.trim() === "" : participant.id === "" || !role}
        />
      </Grid2>

      <Grid2 size={{ xs: 12 }}>
        <Typography fontSize={14} fontWeight={600} color={theme.palette.secondary.main}>
          Participantes 
        </Typography>
        <Stack spacing={1} mt={1} direction={"row"} flexWrap={"wrap"} gap={1}>
          {participants.map((participant, idx) => (
            <ChipParticipant
              key={idx}
              idx= {idx}
              role={rolesOpts.find((role) => role.value === participant.role)?.label || "Rol no encontrado"}
              name={getUserLabel(participant)}
              handleDeleteParticipant= {handleDeleteParticipant}
            />
          ))}
          </Stack>
      </Grid2>

  </Grid2>
  )
}